module.exports = __webpack_public_path__ + "static/media/intersection.aca1b053.svg";